import { ICreateOrgSubscriptionDTO, IUpdateOrgSubscriptionDTO } from '../types'
import { serverApi } from '../utils/request'
import Paths from 'src/utils/paths'

class SubscriptionService {
  public async getSubscriptionPlans() {
    return serverApi.get(Paths.subscriptions.listPlans).then(({ data }) => data)
  }

  public async getOrgSubscription(id: string) {
    return serverApi.get(Paths.subscriptions.getOrgSubscription.replace(':id', id)).then(({ data }) => data)
  }

  public async createOrgSubscription(dto: ICreateOrgSubscriptionDTO) {
    return serverApi.post(Paths.subscriptions.createOrgSubscription, dto).then(({ data }) => data)
  }

  public async updateOrgSubscription(dto: IUpdateOrgSubscriptionDTO) {
    return serverApi.post(Paths.subscriptions.updateOrgSubscription, dto).then(({ data }) => data)
  }
}

const subscriptionService = new SubscriptionService()
export { subscriptionService }



// WEBPACK FOOTER //
// ./src/services/Subscriptions.ts